import InnerPageCSchemes from './InnerPageCSchemes';
export default InnerPageCSchemes;
